const FPConfig = {
    cardInitialMaxLimit: 19,
    cardHoldernameMinLength: 3,
    standingInstruction: {
        frequency: [
            { displayName: 'Weekly', value: 0.25 },
            { displayName: 'Monthly', value: 1 },
            { displayName: 'Quarterly', value: 3 },
            { displayName: 'Six-Monthly', value: 6 },
            { displayName: 'Yearly', value: 12 }
        ],
        amountType: [
            { displayName: 'Maximum', value: 'Maximum' },
            { displayName: 'Fixed', value: 'Fixed' }
        ]
    },
    cardMinMaxLength: {
        VISA: { min: 16, max: 19 },
        MASTER: { min: 16, max: 16 },
        MAESTRO: { min: 16, max: 19 },
        AMEX: { min: 15, max: 15 },
        RUPAY: { min: 16, max: 16 },
        undefined: { min: 15, max: 19 },
        null: { min: 15, max: 19 },
        UNIONPAY: { min: 16, max: 19 }
    },
    timeout: {
        getTxnStatus: 180 // in 180 Seconds
    },
    bqrTimeout: {
        getTxnStatus: 480 // in 480 Seconds for BharatQR transactions
    },
    cardDetail: {
        debit: { apiName: 'DEBIT', displayName: 'Debit Card', code: 'DC' },
        iDebit: { apiName: 'IDEBIT', displayName: 'DebitCard + ATM PIN / OTP', code: 'IDC' },
        credit: { apiName: 'CREDIT', displayName: 'Credit Card', code: 'CC' },
        savedCard: { apiName: 'SC', displayName: 'Saved Cards', code: 'SC' }
    },
    // commented below -FT-25778[STORY-138422]Dynamic Scheme Logo Display on commerce connect hosted page
    // paymentSupportedBrands: {
    //     primary: [ 'pciCss', 'master', 'visa', 'rupay', 'amex', 'norton'],
    //     secondary: [ 'pciCss', 'master', 'visa', 'rupay', 'norton'],
    //     tertiary: [ 'pciCss', 'norton' ],
    //     au:['visa', 'master'],
    //     paymentType: function(brandName){
    //         const possibleCombination = { 
    //             SC: this.primary,
    //             CREDITCARD: this.primary,
    //             DEBITCARD: this.secondary,
    //             IDEBIT: this.secondary,
    //             EMI: this.secondary,
    //             UPI: this.tertiary,
    //             NETBANKING: this.tertiary,
    //             WALLET: this.tertiary,
    //             BHARATQR: this.tertiary,
    //             CARD: this.au
    //         }
    //         return possibleCombination[brandName] ? possibleCombination[brandName] : []
    //     }, 
    // },

    //FT-25778[STORY-138422]Dynamic Scheme Logo Display on commerce connect hosted page
    LogoBasedOnRegion: {
        ims: [ 'imsLogo'],
        nonIms: [ 'nonImsLogo'],
        
        paymentType: function(institutionId){
            const possibleCombination = { 
                47: this.ims,
                21: this.nonIms,
                29: this.nonIms
            }
            return possibleCombination[institutionId] ? possibleCombination[institutionId] : []
        }, 
    },
    emiConfig:{
        cardSegregation:true
    },
    exchangeCurrencyLabel: 'Exchange',
    homeCurrencyLabel: 'Home',
    razor_pay_cancel : 2,
    razor_pay_success : `${process.env.REACT_APP_BASE_SERVICE_API_URL}/razorPayResponsePost?STATUS=PAYMENT SUCCESS`,
    paylater_success : `${process.env.REACT_APP_BASE_SERVICE_API_URL}/commonResponsePost?STATUS=PAYMENT SUCCESS`,
    paylater_failure : `${process.env.REACT_APP_BASE_SERVICE_API_URL}/commonResponsePost?STATUS=PAYMENT FAIL`,
    razor_pay_failure : `${process.env.REACT_APP_BASE_SERVICE_API_URL}/razorPayResponsePost?STATUS=PAYMENT FAIL`,
    qr_success :`${process.env.REACT_APP_BASE_SERVICE_API_URL}/commonResponsePost?STATUS=PAYMENT SUCCESS`,
    qr_failure:`${process.env.REACT_APP_BASE_SERVICE_API_URL}/commonResponsePost?STATUS=PAYMENT FAIL`,
    upi_success:`${process.env.REACT_APP_BASE_SERVICE_API_URL}/commonResponsePost?STATUS=PAYMENT SUCCESS`,
    upi_failiure : `${process.env.REACT_APP_BASE_SERVICE_API_URL}/commonResponsePost?STATUS=PAYMENT FAIL`,
    go_cancel_payment: `${process.env.REACT_APP_BASE_SERVICE_API_URL}/cancelPayment`
}

export default FPConfig;